import { ICargo } from '@/interfaces/cargo';
import {
  IOrder,
  IOrderDDLRes,
  IOrderDriver,
  IOrderPackingList,
  IOrderStatus,
  IOrderSumByDayReq,
  IOrderSumByDayRes,
  IOrderUpdateDocNoReq,
  ISearchOrderReq,
  ISearchOrderRes,
} from '../interfaces/order';
import * as baseAdapter from './baseAdapter';

export const queryOrders = async () => {
  const ret = await baseAdapter.get<IOrder[]>('/manualOrder');
  return ret;
};

export const getOrder = async (id: number) => {
  const ret = await baseAdapter.get<IOrder>('/manualOrder/get/' + id);
  return ret?.data;
};

export const searchOrders = async (req: ISearchOrderReq) => {
  const ret = await baseAdapter.post<ISearchOrderRes>('/manualOrder/gets', req);
  return ret;
};

export const addOrder = async (data: Partial<IOrder>) => {
  const ret = await baseAdapter.post<IOrder>('/manualOrder/create', data);
  return ret;
};

export const editOrder = async (data: Partial<IOrder>) => {
  const ret = await baseAdapter.put(`/manualOrder/update`, data);
  return ret;
};

export const deleteOrder = async (id: number) => {
  const ret = await baseAdapter.deleteRequest(`/manualOrder/deleteOrder/${id}`);
  return ret;
};

export const updateOrderStatus = async (data: IOrderStatus) => {
  const ret = await baseAdapter.post('/manualOrder/updateStatus', data);
  return ret;
};

export const getOrderSumByDay = async (data: IOrderSumByDayReq) => {
  const ret = await baseAdapter.post<IOrderSumByDayRes[]>(
    '/manualOrder/getordersumbyday',
    data,
  );
  return ret;
};

export const orderPrintCount = async (orderId: number) => {
  const ret = await baseAdapter.put(`/manualOrder/printcount/${orderId}`, '');
  return ret;
};

export const orderUpdateDocNo = async (
  orderId: number,
  req: IOrderUpdateDocNoReq,
) => {
  const ret = await baseAdapter.put(`/manualOrder/updateDocNo/${orderId}`, req);
  return ret;
};

export const queryCargo = async (numberPlate: string) => {
  const ret = await baseAdapter.get<ICargo[]>(
    `/manualOrder/getCargo/${numberPlate}`,
  );
  return ret;
};

export const validateIvs = async (ivs: string[]) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const ret = await baseAdapter.post<any>(`/manualOrder/validateIvs`, ivs);
  return ret;
};

export const returnPartialOrder = async (data: Partial<IOrder>) => {
  const ret = await baseAdapter.put(`/manualOrder/returnPartialOrder`, data);
  return ret;
};

export const orderDDL = async (data: Partial<ISearchOrderReq>) => {
  const ret = await baseAdapter.post<IOrderDDLRes[]>(`/manualOrder/DDL`, data);
  return ret;
};

export const queryOrderPackingList = async (orderNo: string) => {
  const ret = await baseAdapter.get<IOrderPackingList[]>(
    `/manualOrder/getPackingList/${orderNo}`,
  );
  return ret;
};

export const patchUpdateDriver = async (data: Partial<IOrderDriver>) => {
  const ret = await baseAdapter.patch(
    `/manualOrder/patchUpdateDriver/${data.id}`,
    data,
  );
  return ret;
};
